export default ({ request }) => ({
  ecomAmzSampleListApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/review',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleShelveApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/shelve',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleCopyApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/copy',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleImageListApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/image/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleImageUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/image/upload',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleImageSetDefaultApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/image/setDefault',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleImageDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/image/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleSkuListApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleSkuAddApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/sku/add',
      method: 'POST',
      data,
    })
  },
  ecomAmzSampleSkuRemoveApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/sku/remove',
      method: 'POST',
      data,
    })
  },
  warehouseTreeApi(data = {}) {
    return request({
      url: '/digitalCenter/master/warehouse/treeList',
      method: 'post',
      data,
    })
  },
  ecomAmzSampleAmzListApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/amz/list',
      method: 'post',
      data,
    })
  },
  ecomAmzSampleStopApi(data = {}) {
    return request({
      url: '/ecom/amz/sample/stop',
      method: 'post',
      data,
    })
  },
})
